import { competitiveIntelligenceResearchTranslations } from './competitive-intelligence-research'
import { analyticsTranslations } from './analytics'

export const static_translation = {
  ...analyticsTranslations.Spanish,
    "audience_access_available_audiences": "Públicos con acceso",
    "audience_access_hcp": "Disponible para profesionales sanitarios",
    "audience_access_partner": "Disponible para Partners",
    "audience_access_staff_us": "Disponible para el personal de EE. UU.",
    "audience_access_staff_global": "Disponible para el personal global",
  "upload_success": "Carga enviada con éxito. En espera de aprobación.",
  "upload_title": "Formulario de solicitud de carga de contenido",
  "mvu_essentials_register_welcome": "Welcome to MagVenture Universe Lite",
  "mvu_essentials_register_access_notice": "Access with this code is limited to a specific number of people. Thank you for not sharing it.",
  "portal_registration_participant_limit_reached": "El registro no está disponible porque se ha alcanzado el número máximo de participantes para este acceso. Póngase en contacto con la persona responsable de su acceso a MagVenture para obtener ayuda.",
  "portal_registration_invite_invalid": "Este enlace de invitación no es válido o ha caducado.",
  "lite_registration_success_title": "Registro completado",
  "lite_registration_success_email_text": "Su acceso a MagVenture Universe Lite está listo. Le hemos enviado un correo de bienvenida con el enlace de acceso. Inicie sesión con el correo y la contraseña que acaba de registrar.",
  "lite_registration_success_text": "Su acceso a MagVenture Universe Lite está listo. Inicie sesión con el correo y la contraseña que acaba de registrar.",
  "lite_registration_success_action": "Ir al inicio de sesión de Lite",
  "accelerator_registration_success_title": "Registro completado",
  "accelerator_registration_success_email_text": "Su acceso al MagVenture Accelerator Program está listo. Le hemos enviado un correo de bienvenida con el enlace de acceso. Inicie sesión con el correo y la contraseña que acaba de registrar.",
  "accelerator_registration_success_text": "Su acceso al MagVenture Accelerator Program está listo. Inicie sesión con el correo y la contraseña que acaba de registrar.",
  "accelerator_registration_success_action": "Ir al inicio de sesión de Accelerator",
  "describe_as_upload": "Complete la información a continuación y cargue los archivos que desea proponer como nuevo contenido para MagVenture Universe. En unos días, nuestro equipo de soporte se pondrá en contacto con usted para brindarle más información sobre su solicitud.",
  "title": "Título",
  "table": "Tipo de contenido",
  "tags": "Etiquetas",
  "tag-types": "Tipos de etiqueta",
  "categories": "Categorías",
  "sub-categories": "Subcategorías",
  "document": "Documento",
  "image": "Imagen",

  "cancel": "Cancelar",
  "send": "Enviar",
  'share_link': 'Compartir enlace',
  'share_link_description': 'Cualquiera con este enlace puede acceder a este contenido durante {days} días. Cópialo y compártelo de forma segura.',
  'share_link_label': 'Comparte este enlace:',
  'copy_link': 'Copiar enlace',
  'copied': '¡Copiado!',
  'share_link_warning': 'Este enlace expirará en {days} días.',
  'share_link_duration': 'Validez (días)',
  'copy': 'Copiar',
  "term_title": "Declaración de cookies y privacidad",
  "register": "Registrarse",
  "login": "Iniciar sesión",
  "email": "Correo electrónico",
  "registration_professional_email_hint": "Utilice su correo electrónico profesional, por ejemplo, nombre@sucentro.com.",
  "password": "Contraseña",
  "signin": "Iniciar sesión",
  "session_expired_sign_in_again": "Tu sesión ha caducado. Inicia sesión de nuevo para continuar.",
  "reset_password": "Restablecer contraseña",
  "fill_the_field": "Rellene el campo",
  "success": "¡Gracias!",
  "onboarding": "Video de incorporación",
  "account_successfully_created": "Nuestro equipo revisará su solicitud y se pondrá en contacto si se necesita más información. Recibirá un correo electrónico cuando su cuenta sea aprobada y esté lista para usar.",
  "close": "Cerrar",
  "salutation": "Tratamiento",
  "first_name": "Nombre",
  "last_name": "Apellido",
  "company_name": "Nombre de la empresa",
  "job_title": "Cargo / Puesto",
  "industry": "Área de actuación",
  "state": "Estado/Provincia",
  "zipcode": "Código postal",
  "phone_number": "Número de teléfono",
  "password_confirmation": "Confirmación de contraseña",
  "mr": "Sr.",
  "mrs": "Sra.",
  "ms": "Srta.",
  "signup": "Crear cuenta",
  "are_you_a_patient_or_a_therapist": "¿Es usted paciente o terapeuta?",
  "create_your_password": "Cree su contraseña",
  "finish": "Finalizar",
  "create_your_account": "Cree su cuenta",
  "back": "Volver",
  "next": "Siguiente",
  "create_a_password": "Cree una contraseña",
  "enter_a_password_for_your_account": "Introduzca una contraseña para su cuenta",
  "subscribe_to_newsletter": "Sí, me gustaría recibir actualizaciones educativas, recursos de TMS e información de eventos de MagVenture.",
  "subscribe_to_newsletter_information": "Puedes darte de baja en cualquier momento. Respetamos tu perfil profesional y solo compartimos contenido relevante.",
  "i_accept_the": "Acepto la",
  "i_accept_the_united": "Política de privacidad de EE. UU.",
  "privacy_policy": "Política de privacidad",
  "send": "Enviar",
  "back_to_login": "Volver al inicio de sesión",
  "enter_your_email_to_recover_your_password": "Introduzca su correo electrónico para recuperar su contraseña",
  "access_the_recovery_link_that_was_sent_to_your_email": "Acceda al enlace de recuperación que fue enviado a su correo electrónico",
  "check_your_email": "Revise su correo electrónico",
  "new_password": "Nueva contraseña",
  "confirm_new_password": "Confirmar nueva contraseña",
  "new_password_and_new_password_confirmation_are_not_the_same": "La nueva contraseña y su confirmación no son iguales",
  "password_changed_successfully": "¡Contraseña cambiada con éxito!",
  "create_a_new_password": "Cree una nueva contraseña",
  "enter_a_new_password_for_your_account": "Introduzca una nueva contraseña para su cuenta",
  "save": "Guardar",
  "one_uppercase_letter": "Una letra mayúscula",
  "one_number": "Un número",
  "at_least_6_characters": "Al menos 6 caracteres",
  "at_least_1_special_character": "Al menos 1 carácter especial",
  "accept_terms": "Aceptar términos",
  "password_and_password_confirmation_must_match": "La contraseña y la confirmación deben coincidir",
  "see_all": "Ver todo",
  "watch_live_now": "Ver en vivo ahora",
  "courses_available_for_you": "Programas disponibles para usted",
  "partners-and-staffs_available_for_you": "Contenido de Partners and Staff disponible para usted",
  "product-information_available_for_you": "Información de productos disponible para usted",
  "articles_available_for_you": "Artículos disponibles para usted",
  "podcasts_available_for_you": "Podcasts disponibles para usted",
  "documents_available_for_you": "Documentos disponibles para usted",

  "support-materials_available_for_you": "Materiales de apoyo a la práctica disponibles para usted",
  "marketing-materials_available_for_you": "Materiales de marketing para la práctica disponibles para usted",
  "service-supports_available_for_you": "Service & Support disponible para usted",
  "product-informations_available_for_you": "Informaciones de productos para la práctica disponibles para usted",
  "media-templates_available_for_you": "Plantillas para redes sociales disponibles para usted",
  "videos_available_for_you": "Videos disponibles para usted",
  "photos_available_for_you": "Fotos disponibles para usted",

  "courses": "Formación y aprendizaje",
  "partners-and-staffs": "Partners and Staff",
  "product-information": "Información de productos",
  "articles": "Artículos",
  "podcasts": "Podcasts",
  "documents": "Documentos",
  "home": "Inicio",
  "favorites": "Favoritos",
  "no_favorites_message": "Todavía no has agregado favoritos.",
  "faq": "Preguntas frecuentes",
  "no_faqs_available": "No hay preguntas frecuentes disponibles.",
  "support": "Ayuda",
  "contact_us": "Contáctenos",
  "my_account": "Mi cuenta",
  "my_certificates": "Mis certificados",
  "logout": "Cerrar sesión",
  "search": "Buscar",
  "frequently_asked_questions": "Preguntas frecuentes",
  "how_can_we_help_you": "¿Cómo podemos ayudarle?",
  "add_new_ticket": "Nueva solicitud de ayuda",
  "all_tickets": "Todas las solicitudes",
  "pending": "Pendientes",
  "closed_tickets": "Solicitudes cerradas",
  "videos_and_contents": "Videos y contenidos",
  "ticket_information": "Información de la solicitud",
  "add_reply": "Añadir respuesta",
  "close_ticket": "Cerrar solicitud",
  "status": "Estado",
  "ticket_id": "ID de la solicitud",
  "created_date": "Fecha de creación",
  "category_department": "Categoría/Departamento",
  "give_feedback": "Enviar opinión",
  "how_would_you_rate_the_way_this_request_was_handled": "¿Cómo calificaría la forma en que se gestionó esta solicitud?",
  "subject": "Asunto",
  "area_departament": "Área / departamento",
  "message": "Mensaje",
  "create_a_new_ticket": "Crear una nueva solicitud",
  "describe_as_soon_as_possible": "Describa su problema y seleccione el departamento adecuado para que nuestro equipo pueda ayudarle lo antes posible",
  "no_records_found": "No se encontraron registros",
  "showing": "Mostrando",
  "of": "de",
  "results": "resultados",
  "subject_title": "Asunto/Título",
  "last_updated": "Última actualización",
  "cancel": "Cancelar",
  "registration_data": "Datos de registro",
  "updated_successfully": "Actualizado correctamente",
  "created_successfully": "Creado correctamente",
  "edit": "Editar",
  "done": "Hecho",
  "filters": "Filtros",
  "search.sections.trainingLearning": "Formación y aprendizaje",
  "search.sections.documents": "Documentos",
  "search.sections.images": "Imágenes",
  "category": "Categoría",
  "filter": "Filtrar",
  "clear": "Limpiar",
  "support_materials": "Materiales de apoyo a la práctica",
  "marketing_materials": "Materiales de marketing para la práctica",
  "media_templates": "Plantillas para redes sociales",
  "videos": "Videos",
  "photos": "Fotos",
  "support-materials": "Materiales de apoyo a la práctica",
  "marketing-materials": "Materiales de marketing",
    "sales-support-materials": "Sales Support Materials",
    "sales-support-materials_available_for_you": "Sales Support Materials available for you",
    "sales_support_materials_empty": "No sales support materials are available yet.",
    "sales_support_materials_error": "We could not load the sales support materials. Please try again.",
    "sales_support_materials_unavailable": "Sales support materials are temporarily unavailable",
  "service-supports": "Service & Support",
  "service_support": "Service & Support",
  "support_videos": "Support Videos",
  "support_videos_empty": "Aún no hay videos de soporte disponibles.",
  "support_videos_unavailable": "Videos de soporte no disponibles",
  "support_videos_error": "No pudimos cargar los videos de soporte. Inténtalo de nuevo.",
  "support_video_unavailable": "Video de soporte no disponible",
  "support_video_media_missing": "Video no disponible",
  "support_video_media_missing_description": "Este video de soporte aún no tiene contenido reproducible.",
  "support_video_about": "Acerca de este video",
  "product-informations": "Informaciones de productos",
  "media-templates": "Plantillas para redes sociales",
  "login_title": "Por favor, inicie sesión",
  "login_title_essentials": "Inicie sesión en MagVenture Universe Lite",
  "accelerator_brand_name": "MagVenture",
  "accelerator_brand_program": "Accelerator Program",
  "login_title_accelerator": "Welcome to the MagVenture Accelerator Portal",
  "accelerator_welcome_intro": "This is your exclusive portal for everything you need to prepare for and participate in the MagVenture Accelerator.",
  "accelerator_welcome_details": "Here you’ll find clinical training focused specifically on Introduction to TMS, Major Depressive Disorder (MDD), and Obsessive Compulsive Disorder (OCD), along with materials and resources from the Accelerator program which will be posted after the program.",
  "accelerator_welcome_login": "Log in to access your training and Accelerator resources.",
  "welcome": "¡Bienvenido! Este es su portal exclusivo para formación clínica, materiales de marketing para la práctica y recursos multimedia, incluidos videos, fotos de tratamiento y plantillas para redes sociales. Inicie sesión para acceder a herramientas diseñadas para apoyar su éxito con MagVenture.",
  "existing_users": "Usuarios existentes",
  "enter_credentials_to_continue": "Introduzca sus credenciales para continuar donde lo dejó.",
  "new_users": "Nuevos usuarios",
  "register_link_text": "Registrarse",
  "register_and_gain_access_part1": "¿Necesita una cuenta? Vaya a ",
  "register_and_gain_access_part2": " y obtenga acceso completo a nuestra plataforma exclusiva de aprendizaje y recursos.",
  "contact": "Contáctenos",
  "contact.topicCategory": "Seleccione la categoría del tema",
  "contact.topicCategory.label": "Categoría del tema",
  "contact.chooseSubject": "Elija el asunto que mejor se ajuste a su solicitud.",
  "contact.message": "Mensaje",
  "contact.message.label": "Mensaje",
  "contact.describeIssue": "Describa su problema con detalle. Nuestro equipo responderá lo antes posible.",
  "contact.fileAttachment": "Adjuntar un archivo",
  "contact.fileAttachment.label": "Archivo adjunto",
  "contact.attachmentHelp": "Opcionalmente, puede adjuntar una captura de pantalla o archivo relacionado con su solicitud (por ejemplo, JPG, PNG, PDF, DOC).",
  "contact.preferredContact": "Método de contacto preferido",
  "contact.preferredContact.label": "Método de contacto preferido",
  "contact.contactPreference": "¿Cómo prefiere que nos pongamos en contacto con usted sobre este problema?",
  "contact.maximum_characters": "Máximo: 1000 caracteres",
  "contact.email.label": "Correo electrónico",
  "contact.phone.label": "Teléfono",
  "contact.technical_support": "Preguntas sobre el contenido en MagVenture Universe",
  "contact.video_streaming": "Problema con la transmisión de video",
  "contact.questions_about_products": "Pregunta sobre productos/servicios de MagVenture",
  "contact.material_download": "Problema con la descarga de material",
  "contact.suggestion": "Sugerencia",
  "contact.other": "Otro",
  "contact.file": "Elegir archivos",
  "contact.submit": "Enviar",
  "contact.is_required": "es obligatorio",
  "contact.success": "Contacto enviado con éxito",
  "register.undertems": "El acceso a MagVenture Universe está sujeto a revisión y aprobación. Las solicitudes de registro pueden tardar hasta 2 días laborables en ser aprobadas.",
  "courses-webnars-trainning": "Cursos, seminarios web y formaciones",
  "usshop": "Tienda de EE. UU.",
  "chat": "Agente de chat",
  "country": "País",
  "verify_email": "Verificar correo electrónico",
  "enter_the_code_sent_to_your_email": "Introduzca el código enviado a su correo electrónico",
  "we_sent_a_code_to_email": "Hemos enviado un código de verificación a",
  "enter_verification_code": "Introduzca el código de verificación",
  "code_expires_in": "El código vence en",
  "verify": "Verificar",
  "resend_code_in": "Reenviar código en",
  "resend_code": "Reenviar código",
  "a_new_code_has_been_sent": "Se ha enviado un nuevo código.",
  "please_confirm_you_are_not_a_robot": "Confirme que no es un robot.",
  "email_verified_successfully": "Correo electrónico verificado correctamente.",
  "continue": "Continuar",
  "notifications": "Notificaciones",
  "unread_notifications": "notificaciones no leídas",
  "unread_notification": "notificación no leída",
  "unread": "No leída",
  "mark_all_notifications_read": "Marcar todas como leídas",
  "notifications_update_error": "No se pudieron actualizar las notificaciones.",
  "try_again": "Intentar de nuevo",
  "notifications_load_error": "No se pudieron cargar las notificaciones",
  "notifications_load_error_description": "Compruebe su conexión e inténtelo de nuevo.",
  "notifications_empty": "Aún no hay notificaciones",
  "notifications_empty_description": "Las actualizaciones y actividades importantes aparecerán aquí.",
  "notification_not_found": "Notificación no encontrada",
  "notification_not_found_description": "Esta notificación ya no está disponible o no tiene acceso a ella.",
  "back_to_notifications": "Volver a las notificaciones",
  "open_notification": "Abrir",
  "loading_notifications": "Cargando notificaciones",
  "loading_notification": "Cargando notificación",
  "notifications_subtitle": "Consulta actualizaciones, nuevos cursos y actividad importante en un solo lugar.",
  "recent_activity": "Actividad reciente",
  "notifications_all_read": "Todo está al día",
  "staff_essentials_invites_title_required": "El título es obligatorio.",
  "staff_essentials_invites_updated": "Invitación actualizada.",
  "staff_essentials_invites_created": "Invitación creada.",
  "staff_essentials_invites_link_unavailable": "El enlace de invitación no está disponible.",
  "staff_essentials_invites_link_copied": "Enlace de invitación copiado.",
  "staff_essentials_invites_copy_prompt": "Copia este enlace de invitación:",
  "staff_essentials_invites_eyebrow": "MagVenture Universe",
  "staff_essentials_invites_menu_title": "MVU Lite Invitations",
  "staff_essentials_invites_title": "MVU Lite Invitations",
  "staff_essentials_invites_subtitle": "Crea enlaces de invitación para MagVenture Universe Lite y acompaña cuántos registros consumió cada enlace.",
  "staff_essentials_invites_refresh": "Actualizar",
  "staff_essentials_invites_create": "Crear invitación",
  "staff_essentials_invites_total": "Total de invitaciones",
  "staff_essentials_invites_active": "Activas",
  "staff_essentials_invites_registrations": "Registros",
  "staff_essentials_invites_remaining": "Restantes",
  "staff_essentials_invites_links": "Enlaces de invitación",
  "staff_essentials_invites_found_singular": "invitación encontrada",
  "staff_essentials_invites_found_plural": "invitaciones encontradas",
  "staff_essentials_invites_none_created": "Aún no hay enlaces de invitación",
  "staff_essentials_invites_syncing": "Sincronizando",
  "staff_essentials_invites_live_data": "Datos en vivo",
  "staff_essentials_invites_loading_links": "Cargando enlaces de invitación...",
  "staff_essentials_invites_column_title": "Título",
  "staff_essentials_invites_column_link": "Enlace",
  "staff_essentials_invites_column_status": "Estado",
  "staff_essentials_invites_column_used": "Usados",
  "staff_essentials_invites_column_remaining": "Restantes",
  "staff_essentials_invites_column_expires": "Vence",
  "staff_essentials_invites_column_created": "Creado",
  "staff_essentials_invites_column_actions": "Acciones",
  "staff_essentials_invites_active_status": "Activa",
  "staff_essentials_invites_inactive_status": "Inactiva",
  "staff_essentials_invites_unlimited": "Ilimitado",
  "staff_essentials_invites_copy_link": "Copiar enlace",
  "staff_essentials_invites_history": "Historial",
  "staff_essentials_invites_edit": "Editar",
  "staff_essentials_invites_empty_title": "Aún no hay invitaciones Lite",
  "staff_essentials_invites_empty_description": "Crea el primer enlace de invitación para comenzar a acompañar registros.",
  "staff_essentials_invites_edit_modal": "Editar invitación",
  "staff_essentials_invites_create_modal": "Crear invitación",
  "staff_essentials_invites_generated_by_strapi": "El código de invitación y el enlace público son generados por Strapi.",
  "staff_essentials_invites_field_title": "Título",
  "staff_essentials_invites_field_maximum_uses": "No. of users having access to this invitation",
  "staff_essentials_invites_field_expires_at": "Vence en",
  "staff_essentials_invites_history_modal": "Historial de invitación",
  "staff_essentials_invites_loading_history": "Cargando historial...",
  "staff_essentials_invites_no_institution": "Sin institución",
  "staff_essentials_invites_no_registrations": "Aún no hay registros para esta invitación.",
  "staff_essentials_invites_locked_content_title": "Acceso al contenido",
  "lite_invite_default_content_help": "Todo el contenido configurado para Lite está disponible de forma predeterminada. Utiliza las opciones avanzadas para personalizar el acceso.",
  "staff_essentials_invites_locked_content_description": "El contenido marcado está disponible para los usuarios registrados con esta invitación. Desmarca un elemento para bloquear el acceso.",
  "staff_essentials_invites_locked_content_selected": "con acceso",
  "staff_essentials_invites_locked_content_select_visible": "Permitir resultados visibles",
  "staff_essentials_invites_locked_content_clear": "Bloquear todo el contenido",
  "staff_essentials_invites_locked_content_search": "Buscar contenido Lite",
  "staff_essentials_invites_locked_content_filter": "Tipo de contenido",
  "staff_essentials_invites_locked_content_all_types": "Todos los tipos",
  "staff_essentials_invites_locked_content_loading": "Cargando catálogo...",
  "staff_essentials_invites_locked_content_empty": "No hay contenido coincidente.",
  "staff_essentials_invites_locked_content_error": "No se pudo cargar el catálogo Lite.",
  "staff_essentials_invites_content_preset_title": "Preselección de contenido",
  "staff_essentials_invites_content_preset_description": "Selecciona uno o más grupos para sustituir la selección actual por sus contenidos combinados. Después, personaliza los elementos de abajo.",
  "staff_essentials_invites_content_preset_placeholder": "Grupo de contenido predefinido",
  "staff_essentials_invites_content_preset_custom": "Selección personalizada (sin preselección)",
  "staff_essentials_invites_content_preset_loading": "Cargando preselecciones de contenido...",
  "staff_essentials_invites_content_preset_error": "No se pudieron cargar las preselecciones de contenido.",
  "staff_essentials_invites_content_preset_empty": "No hay preselecciones activas. Aún puedes seleccionar contenido manualmente.",
  "staff_essentials_invites_content_preset_applied": "Preselección aplicada",
  "staff_essentials_invites_content_preset_applied_description": "Este contenido se copió en la invitación. Puedes personalizarlo abajo sin cambiar el grupo en Strapi.",
  "exclusive_content_title": "Contenido exclusivo",
  "exclusive_content_message": "Este contenido es exclusivo para clientes de MagVenture.",
  "survey_load_error": "No se pudo cargar esta encuesta.",
  "survey_unavailable": "Encuesta no disponible",
  "survey_back_to_course": "Volver al curso",
  "survey_thank_you": "Gracias por tus comentarios",
  "survey_completed_description": "Tus respuestas se guardaron. Puedes continuar con el curso.",
  "survey_submitted": "Enviada",
  "survey_continue_course": "Continuar curso",
  "survey_course_feedback": "Comentarios del curso",
  "survey_intro_description": "Responde las siguientes preguntas sobre tu experiencia de formación.",
  "survey_questions": "preguntas",
  "survey_minutes": "minutos",
  "survey_account_linked": "Guardada en tu cuenta",
  "survey_start": "Iniciar encuesta",
  "survey_progress": "Progreso de la encuesta",
  "survey_optional": "Opcional",
  "survey_required": "Obligatoria",
  "survey_text_placeholder": "Escribe tu respuesta aquí...",
  "survey_back": "Volver",
  "survey_submit": "Enviar comentarios",
  "survey_continue": "Continuar",
  "survey_required_answer": "Esta pregunta es obligatoria.",
  "survey_required_before_quiz": "Completa la encuesta obligatoria antes de comenzar este cuestionario.",
  "survey_required_title": "Encuesta obligatoria",
  "survey_open": "Abrir encuesta",
  "survey_completed_action": "Encuesta completada",
  "survey_complete_required": "Completar encuesta obligatoria",
  "survey_course_completed": "Curso completado",
  "survey_next_step": "Siguiente paso",
  "survey_share_experience": "Comparte tu experiencia",
  "survey_opens_in": "Abriendo la encuesta en",
  "survey_seconds": "segundos",
  "survey_answer_now": "Responder encuesta",
  "survey_stay_here": "Permanecer aquí",
  "user_approvals_menu_title": "Aprobaciones de usuarios",
  "user_approvals_eyebrow": "Gestión de acceso",
  "user_approvals_title": "Aprobaciones de usuarios",
  "user_approvals_subtitle": "Revisa las solicitudes de acceso pendientes asignadas a tu ámbito de aprobación.",
  "user_approvals_pending_count": "pendientes",
  "user_approvals_refresh": "Actualizar",
  "user_approvals_pending_requests": "Solicitudes pendientes",
  "user_approvals_search_placeholder": "Buscar por nombre, correo o empresa",
  "user_approvals_unavailable": "Aprobaciones no disponibles",
  "user_approvals_auth_required": "Inicia sesión para acceder a las solicitudes.",
  "user_approvals_not_authorized": "No hay un responsable de aprobación activo vinculado a esta cuenta.",
  "user_approvals_network_error": "Error de red. Inténtalo de nuevo.",
  "user_approvals_load_error": "No se pudieron cargar las solicitudes de aprobación.",
  "user_approvals_empty": "No hay aprobaciones pendientes.",
  "user_approvals_empty_description": "Las nuevas solicitudes asignadas a tu ámbito aparecerán aquí.",
  "user_approvals_no_search_results": "No hay aprobaciones coincidentes",
  "user_approvals_no_search_results_description": "Prueba con otro nombre, correo o empresa.",
  "user_approvals_created_at": "Creada",
  "user_approvals_name": "Nombre",
  "user_approvals_email": "Correo",
  "user_approvals_company": "Empresa",
  "user_approvals_country": "País",
  "user_approvals_region": "Región",
  "user_approvals_location": "Ubicación",
  "user_approvals_status": "Estado",
  "user_approvals_actions": "Acciones",
  "user_approvals_approved": "Aprobado",
  "user_approvals_rejected": "Rechazado",
  "user_approvals_approve": "Aprobar",
  "user_approvals_reject": "Rechazar",
  "user_approvals_already_processed": "Esta solicitud ya fue procesada.",
  "user_approvals_process_error": "No se pudo procesar esta solicitud.",
  "user_approvals_approve_success": "Usuario aprobado correctamente.",
  "user_approvals_reject_success": "Usuario rechazado correctamente.",
  "user_approvals_manual_review_required": "Revisión manual requerida",
  "user_approvals_company_informed": "Empresa indicada en el registro",
  "user_approvals_phone": "Teléfono",
  "user_approvals_customer_select": "Cliente / Clínica",
  "user_approvals_search_companies": "Buscar cliente o clínica",
  "user_approvals_no_companies": "No se encontró ningún cliente o clínica",
  "user_approvals_company_load_error": "No se pudieron cargar los clientes o clínicas.",
  "user_approvals_confirm_title": "Aprobar usuario",
  "user_approvals_confirm_description": "Revise el registro y confirme el cliente antes de aprobar el acceso.",
  "user_approvals_association_confirmation": "Este usuario se asociará con:",
  "user_approvals_confirm_approval": "Confirmar aprobación",
  "mag.title": "Maggie",
  "mag.subtitle": "Your learning companion",
  "mag.preview_badge": "Preview",
  "mag.open_aria": "Open Maggie assistant",
  "mag.close_aria": "Close Maggie assistant",
  "mag.launcher_tooltip": "Talk to Maggie",
  "mag.intro_title": "Hi! I'm Maggie.",
  "mag.intro_body": "How can I help?",
  "mag.dismiss_intro_aria": "Dismiss Maggie introduction",
    "mag.welcome": "¡Hola! Soy Maggie. ¿Qué te gustaría explorar hoy?",
    "mag.welcome_named": "¡Hola, {name}! Soy Maggie. ¿Qué te gustaría explorar hoy?",
  "mag.quick_actions_label": "Try asking",
  "mag.quick.find_course": "Find a course",
  "mag.quick.explore_trails": "Explore Learning Paths",
  "mag.quick.continue_learning": "Continue learning",
  "mag.quick.product_tutorials": "Find product tutorials",
  "mag.quick.about_magventure": "Learn how MagVenture works",
  "mag.placeholder": "Ask Maggie a question...",
  "mag.composer_label": "Message to Maggie",
  "mag.send_aria": "Send message to Maggie",
  "mag.preview_response": "Puedo responder usando la biblioteca de aprendizaje de MagVenture.",
  "mag.local_error": "Maggie no pudo preparar una respuesta. Inténtalo de nuevo.",
  "mag.typing": "Maggie está preparando una respuesta",
  "mag.you_label": "Your message",
  "mag.mag_label": "Message from Maggie",
  "mag.avatar_fallback": "Maggie avatar fallback",
  "mag.loading": "Opening Maggie...",
    "mag.sources": "Fuentes",
    "mag.page": "Página",
  "mag.feedback_question": "¿Te resultó útil?",
  "mag.feedback_up": "Respuesta útil",
  "mag.feedback_down": "Respuesta no útil",
  "mag.feedback_thanks": "Gracias por tus comentarios.",
  "mag.feedback_error": "No se pudo enviar el comentario.",
    "mag.feedback_form.title": "Enviar comentarios",
    "mag.feedback_form.open": "Haz clic aquí para enviar comentarios",
    "staff_essentials_invites_content_locked": "Bloqueado",
    "staff_essentials_invites_content_available": "Acceso permitido",
    "mag.feedback_form.description": "Guardaremos tus comentarios para que el equipo MagVenture los revise. Hasta 4.000 caracteres.",
    "mag.feedback_form.placeholder": "Tus comentarios",
    "mag.feedback_form.submit": "Enviar comentarios",
    "mag.feedback_form.cancel": "Volver al chat",
    "mag.competitor_feedback.prompt": "¡Hola! Puedo ayudarte a explorar el Competitive Hub. ¿Qué te gustaría saber? También puedes usar el botón de comentarios para enviar una sugerencia.",
    "mag.competitor_feedback.prompt_named": "¡Hola, {name}! Puedo ayudarte a explorar el Competitive Hub. ¿Qué te gustaría saber? También puedes usar el botón de comentarios para enviar una sugerencia.",
  "mag.competitor_feedback.placeholder": "Share your Competitor Hub feedback...",
    "mag.competitor_feedback.success": "¡Gracias! Guardamos tus comentarios para que el equipo los revise.",
    "mag.competitor_feedback.error": "No pudimos guardar tus comentarios. El mensaje sigue en el formulario; inténtalo de nuevo.",
  "mag.feedback_reason.not_helpful": "No fue útil",
  "mag.feedback_reason.wrong_source": "Fuente incorrecta",
  "mag.feedback_reason.unclear": "Poco clara",
  "mag.feedback_reason.too_general": "Muy general",
  "mag.feedback_reason.unsafe": "Insegura",
  "competitive_intelligence_menu_title": "Inteligencia competitiva",
  "competitive_intelligence_eyebrow": "Inteligencia de mercado",
  "competitive_intelligence_title": "Inteligencia competitiva",
  "competitive_intelligence_description": "Una visión actual de la investigación competitiva, las señales del mercado y las fuentes sociales seguidas por MagVenture.",
  "competitive_intelligence_freshness_unknown": "Hora de actualización no disponible",
  "competitive_intelligence_overview_heading": "Resumen de inteligencia",
  "competitive_intelligence_metric_competitors": "Competidores seguidos",
  "competitive_intelligence_metric_research": "Registros de investigación",
  "competitive_intelligence_metric_market": "Señales del mercado",
  "competitive_intelligence_metric_social": "Publicaciones sociales",
  "competitive_intelligence_sources_title": "Fuentes de investigación",
  "competitive_intelligence_sources_description": "Cobertura y actualidad de la base de Inteligencia Competitiva.",
  "competitive_intelligence_records": "registros",
  "competitive_intelligence_sources_empty": "Aún no hay detalles por fuente.",
  "competitive_intelligence_loading": "Cargando el resumen de Inteligencia Competitiva",
  "competitive_intelligence_empty_title": "Aún no hay datos de inteligencia",
  "competitive_intelligence_empty_description": "El proceso de datos aún no ha publicado registros para este resumen.",
  "competitive_intelligence_denied_title": "Acceso no disponible",
  "competitive_intelligence_denied_description": "Tu cuenta no tiene acceso a Inteligencia Competitiva.",
  "competitive_intelligence_unavailable_title": "Inteligencia Competitiva no disponible",
  "competitive_intelligence_unavailable_description": "No se puede acceder al servicio ahora. Inténtalo de nuevo en breve.",
  "competitive_intelligence_error_title": "No se pudo cargar el resumen",
  "competitive_intelligence_error_description": "Una respuesta inesperada impidió cargar este resumen.",
  ...competitiveIntelligenceResearchTranslations.Spanish
}
